import { useState } from "react";
import { BiSolidEditAlt } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { UNIQUE_STORE_PRICE } from "../../../network/config/apiPaths";
import { useDispatch } from "react-redux";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import axios from "axios";
import { axiosApi } from "../../../network/service/config/AaxiosUtil";

function ProductPriceItem(props) {
   
    const navigate=useNavigate();
    const dispatch=useDispatch();


    
    const [item, setItem] = useState(props.price);
    const [itemStatus, setitemStatus] = useState(item.status);
      const onStatusChange = async () => {
        let status = "YES";
        if (item.status == "NO") {
          status = "YES";
        } else {
          status = "NO";
        }
    
        await axiosApi
          .get(API_CONFIG.API_HOST + UNIQUE_STORE_PRICE.PRODUCT_PRICE_STATUS_PATH+`id=${item.id}&status=${status}`,{
            API_HEADERS,
          })
          .then((response) => {
            console.log("Product price UPODATE", response);
            if (response.status === 200 && response.data.status === true) {
              setItem(item, (item.status = status));
              setitemStatus(status);
            } else {
            //   dispatch(
            //     updateMessage({
            //       display: true,
            //       message: "Error While updating info",
            //     })
            //   );
            }
          });
    
        // await dispatch(createUpdateAction(requestBody)).then((response) => {
        //   if (response.status == true) {
        //     setItem(product, (product.status = status));
        //     setitemStatus(status);
        //   } else {
        //     dispatch(
        //       updateMessage({
        //         display: true,
        //         message: "Error While updating info",
        //       })
        //     );
        //   }
        // });
      };
    return (
        <div className=" w-100">
            <div className="d-flex flex-row mb-3 p-2 shadow w-100">

                <div className="w-50">
                    <p>{item.quantity}</p>
                    <p>
                        ₹{item.offer_price} <span style={{ textDecoration: "line-through" }}>₹{item.price}</span>
                    </p>
                </div>
                <div className="d-flex flex-row justify-content-end w-50"
                    onClick={() => navigate("/productPricing", { state: { productId: props.productId, productStoreId: props.storeId, priceObj: item } })}
                >
                    <BiSolidEditAlt />
                </div>
                <div className="form-check form-switch d-flex flex-row justify-content-center m-1">

                    <input type="checkbox"
                        className="form-check-input"
                        onChange={onStatusChange}
                        checked={itemStatus=="YES" ? true : false}
                        // 
                        role="switch"
                    />
                </div>
            </div>
        </div>
    )
}
export default ProductPriceItem